<!--
TELA PARA ENTRADA DE INFORMACOES PARA ENVIO DE EMAILS

EXEMPLO DE USO:

  <nf-envio v-if="showFormEmail" :index="nf.codnf" :tipo="DANFE" urlTemplate="" title="Envio de Danfe"
    @closeform="closeFormEmail" @send="handleSendEmail"></nf-envio>


  closeFormEmail() {
      this.showFormEmail = false
  },

  async handleSendEmail(data) {
      //cahamda para envio de email da danfe
      let sendData = data
      sendData.codnf = this.nf.codnf
      this.closeFormEmail()
      await apiEmailPDF(this, 'danfe/', sendData)
  },

-->

<script>
import { SysVars } from '../main';
import { apiORDS, urlORDS } from '../shared/api-functions'
import Vue from 'vue';

export default {
    name: 'email-form',
    props: {
        index: '',             //CODIGO DO PEDIDO, NF, ETC
        tipo: {type: String},  //PEDV, DANFE
        codpart: {type: [String, Number]},
        urlTemplate: {type: String},  //URL DE UM TEMPLATE ESPECIFICO
        title: {type: String},
    },

    data () {
        return {
          errorMessage: '',
          error: false,
          template: {},
          sendto: '',
          text: '',
          subject: '',
          emails: [{ email: '' }],  //LISTA DE EMAILS PARA ENVIO
          listEmails: [
              { email: 'Adicionar Email', selected: false },
            ],  //LISTA DE EMAILS PARA SELEÇÃO
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleEnviar () {
            //botao enviar

            let emails = []

            for (var x = 0; x < this.emails.length; x++) {
              emails.push(this.emails[x].email)
            }

            const data = {
                emails: emails,
                subject: this.subject,
                text: this.text,
                sender: this.template.sender,
                sendername: this.template.sendername }

            this.$emit('send', data)
        },

        closeForm () {
            this.$emit('closeform')
        },

        validaEmail () {

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.handleEnviar()
                }
            })

        },

        handleDeleteEmail (index) {
            //exclui um email
            if (this.emails[index].selectedIndex) {
              this.listEmails[this.emails[index].selectedIndex].selected = false
            }
            this.emails.splice(index, 1)
        },

        handleSelectEmail(index) {
            //adiciona selecionado
            let email = { email: this.listEmails[index].email, selectedIndex: index }

            if (index === 0) {
              //ADICIONAR EMAIL
              email.email = ''
            } else {
              this.listEmails[index].selected = true
            }
            if (!this.emails[0].email) {
              this.emails[0].email = email.email
            } else {
              this.emails.push(email)
            }
        },

        handleAdicionarEmail () {
            //adiciona email
            let email = { email: '' }
            this.emails.push(email)
        },

        async loadTemplate () {
            //CARREGA O TEMPLATE DO EMAIL DA DANFE OU PEDIDO DE VENDA
            let url = ''

            if (this.tipo == 'DANFE') {
              url = 'template/danfe/'
            } else if (this.tipo == 'PEDV') {
              url = 'template/pedv/'
            } else if (this.tipo == 'CCE') {
              url = 'template/cce/'
            } else if (this.tipo == 'CIELOSUPERLINK') {
              url = 'template/cielosuperlink/'
            } else if (this.tipo == 'COMPRA') {
              url = 'template/compra/'
            } else if (!this.urlTemplate) {
              return
            } else {
              url = this.urlTemplate
            }

            url = this.$store.getters.urlOrds + url + this.index
            console.log(url);
            const data = await apiORDS(url, {})
            if (data) {
               this.template = data
            }
        },
    },

    watch: {
        template: function() {
            if (!this.template.subject) return
            // this.listEmails = []
            this.sendto = this.template.sendto
            this.subject = this.template.subject
            this.text = this.template.text
            if (this.template.listEmails && this.template.listEmails.length > 0) {
              for (var x = 0; x < this.template.listEmails.length; x++) {
                this.listEmails.push({ email: this.template.listEmails[x], selected: false })
              }
            }
            this.emails[0].email = this.sendto
        },
    },

    mounted () {
        this.$nextTick(function () {
            this.$refs.sendto[0].focus()

        })
    },

    created () {
        this.loadTemplate()
    }

}

</script>

<template>
  <transition>
    <div id="mymodal" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container nb-email-container">
          <div class="nb-modal-header">
            <h4 class="def-title">{{ title }}</h4>
            <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="nb-modal-scrollable-body">
            <div class="row" v-for="(email, index) in emails" :key="index">
                <form-field v-if="index===0" label="Email" ref="sendto" v-model="email.email" type="email" col="12"
                    :name="'email_' + index" case="lower" :v-errors="errors" v-validate="{ max: 255, required: true, email: true }">
                </form-field>
                <form-field v-if="index > 0" v-model="email.email" type="email" col="12"
                    :name="'email_' + index" case="lower" :v-errors="errors" v-validate="{ max: 255, required: true, email: true }">
                <a href="javascript:void(0);"
                  data-toggle="tooltip" data-placement="top"
                  :title="title"
                  :tabindex="1"
                  @click="handleDeleteEmail(index)"><i class="fa fa-trash" aria-hidden="true"></i> Remover E-mail </a>
                </form-field>
            </div>

            <!-- LISTA DE BOTOES DE EMAILS -->
            <div class="row col nb-margin-bottom">
              <div v-for="(email, index) in listEmails" :key="index">
                  <v-button v-if="!email.selected" icon="fa-envelope-open" :tabindex="1" :label="email.email" title="" @click="handleSelectEmail(index)"></v-button>
              </div>
            </div>

            <div class="row">
                <form-field v-model="subject" type="text" col="12" label="Assunto"
                    name="subject" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="row">
                <form-field v-model="text" case="normal" type="memo" col="12" label="Texto do Email"
                    name="text" :v-errors="errors" v-validate="{}"></form-field>
            </div>
            <div class="nb-modal-scrollable-footer">
                <v-button ref="btnConfirm" label="Enviar Email" title="" :nb-btdef="true" @click="validaEmail"></v-button>
                <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
            </div>
          </div>
      </div>
    </div>
  </transition>
</template>

<style>

.nb-email-container {
  width: 100%;
  max-width: 680px;
}
</style>



// WEBPACK FOOTER //
// src/components/email-form.vue